import React, { useEffect, useState } from "react";
import visitorDashboardBanner from "../../assets/img/visitordashboardbanner.jpg";
import { LineChart } from "../../components/charts/Line";
import DoughnutChart from "../../components/charts/Doughnut";
import { BarChart } from "../../components/charts/Bar";
import MapWithMarkers from "../../components/charts/MapWithMarkers";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { Link } from "react-router-dom";
import FullScreenLoader from "../../components/FullScreenLoader";
import PayRegChallanModal from "./PayRegChallanModal";
import RegFeeStatusModal from "./RegFeeStatusModal";
import AssessmentDateStatusModal from "./AssessmentDateStatusModal";
import AssessmentMarksStatusModal from "./AssessmentMarksStatusModal";
import InterviewDateStatusModal from "./InterviewDateStatusModal";
import InterviewRemarksStatusModal from "./InterviewRemarksStatusModal";
import AdmissionFeeStatusModal from "./AdmissionFeeStatusModal";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
// import Parent_studentDashboard from "./ParentStudentDashboard";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import NotificationEventTypes from "../../constants/notificationEventsEnum";
import { useWorkflow } from "../../context/WorkflowContext";
import WorkflowProcessIds from "../../constants/WorkflowProcessIdsEnum";
import DBObjectIds from "../../constants/DBObjectsIdsEnum";
import RegPaymentProofModal from "../../components/modals/RegPaymentProofModal";

function ApplicationStatus() {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const roleId = localStorage.getItem("roleId");
  const [fileUrls, setFileUrls] = useState({});
  const [fileCounts, setFileCounts] = useState({}); // Track the number of files uploaded
  const [triggerRerender, setTriggerRerender] = useState(false);
  const { workflowParams, setWorkflowParams } = useWorkflow();

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {},
  });
  const organizationId =
    localStorage.getItem("organizationId") === "null" ||
    localStorage.getItem("organizationId") === "0"
      ? 0
      : localStorage.getItem("organizationId");

  const centerId =
    localStorage.getItem("centerId") === "0" ||
    localStorage.getItem("centerId") === "null"
      ? 0
      : localStorage.getItem("centerId");

  const [registrationsData, setRegistrationsData] = useState([]);
  const [workflowSteps, setWorkflowSteps] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showRegFeeModal, setShowRegFeeModal] = useState(false);
  const [regFeeModalData, setRegFeeModalData] = useState(null);
  const [showAssessmentDateModal, setShowAssessmentDateModal] = useState(false);
  const [assessmentDateModalData, setAssessmentDateModalData] = useState(null);
  const [showAssessmentMarksModal, setShowAssessmentMarksModal] =
    useState(false);
  const [assessmentMarksModalData, setAssessmentMarksModalData] =
    useState(null);
  const [showInterviewDateModal, setShowInterviewDateModal] = useState(false);
  const [interviewDateModalData, setInterviewDateModalData] = useState(null);
  const [showInterviewRemarksModal, setShowInterviewRemarksModal] =
    useState(false);
  const [interviewRemarksModalData, setInterviewRemarksModalData] =
    useState(null);
  const [showAdmissionFeeModal, setShowAdmissionFeeModal] = useState(false);
  const [admissionFeeModalData, setAdmissionFeeModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showRegPaymentProofModal, setShowRegPaymentProofModal] =
    useState(false);
  const [regPaymentProofModalData, setRegPaymentProofModalData] =
    useState(null);
  const [paymentProofType, setPaymentProofType] = useState("");

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const getRegistrationsList = async () => {
    if (!token) {
      console.error("Unauthorized: No token found.");
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await get(
        `Student/GetPupilsInformationByUserId?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRegistrationsData(response || []);
    } catch (error) {
      console.error("Error fetching registrations:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchWorkflowSteps = async (ids) => {
    if (!ids.length) return;
    try {
      const payload = {
        ProcessId: WorkflowProcessIds.NewRegistration,
        DBObjectId: DBObjectIds.StudentFirstRegistrations,
        DBObjectLocationIds: ids.join(","),
        UserId: Number(localStorage.getItem("userId")),
        RoleId: Number(localStorage.getItem("roleId")),
      };
      const response = await post(`workflow/getNextStepInfo`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.success) {
        const stepMap = Object.fromEntries(
          response.workflowStepInfoByRecordList.map((step) => [
            step.recordId,
            {
              id: step.nextStepId,
              name: step.nextStep,
              icon: step.nextStepIcon,
              stepInfo: step,
            },
          ])
        );
        setWorkflowSteps(stepMap);
      } else {
        toast.error(response.message || "Failed to fetch workflow steps");
      }
    } catch (error) {
      console.error("Error fetching workflow steps:", error);
      toast.error("Failed to fetch workflow steps");
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    await Promise.all([getRegistrationsList()]);
    setIsLoading(false);
    if (registrationsData.length) {
      const ids = registrationsData.map((row) => row.id);
      await fetchWorkflowSteps(ids);
    }
  };

  useEffect(() => {
    fetchData();
  }, [triggerRerender]);

  useEffect(() => {
    if (registrationsData.length) {
      const ids = registrationsData.map((row) => row.id);
      fetchWorkflowSteps(ids);
    }
  }, [registrationsData]);

  const handleRegFeeModalClick = async (event, id) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await get(
        `AssessmentType/GetRegistartionVoucherByRegIdAsync?studentFirstRegistrationId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.isSuccess) {
        setRegFeeModalData(response.registrationVoucher);
        setShowRegFeeModal(true);
      } else {
        console.error(
          "Error fetching registration fee details:",
          response?.message
        );
      }
    } catch (error) {
      console.error("Error fetching registration voucher:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAssessmentDateModalClick = async (event, id) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await get(
        `CommonSettings/GetScheduleLogByStudentFirstRegistrationIdAsync?studentFirstRegistrationId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.isSuccess) {
        setAssessmentDateModalData(response.scheduleLog?.[0] || null);
        setShowAssessmentDateModal(true);
      } else {
        console.error(
          "Error fetching assessment date details:",
          response?.message
        );
      }
    } catch (error) {
      console.error("Error fetching assessment date:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAssessmentMarksModalClick = async (event, id, classId) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await get(
        `AssessmentPlan/GetCenterClassesAssessmentPlanByCenterClassAndRegistartionIdAsync?centerId=${centerId}&classId=${classId}&registartionId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.isSuccess) {
        setAssessmentMarksModalData(response);
        setShowAssessmentMarksModal(true);
      } else {
        console.error(
          "Error fetching assessment marks details:",
          response?.message
        );
      }
    } catch (error) {
      console.error("Error fetching assessment marks:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInterviewDateModalClick = async (event, id) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await get(
        `CommonSettings/GetScheduleLogByScheduleTypeAndIdActiveRecordAsync?ScheduleType=Interview&studentFirstRegistrationId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.isSuccess) {
        setInterviewDateModalData(response.scheduleLog);
        setShowInterviewDateModal(true);
      } else {
        console.error(
          "Error fetching interview date details:",
          response?.message
        );
      }
    } catch (error) {
      console.error("Error fetching interview date:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInterviewRemarksModalClick = async (event, row) => {
    event.preventDefault();
    setLoading(true);
    try {
      setInterviewRemarksModalData(row);
      setShowInterviewRemarksModal(true);
    } catch (error) {
      console.error("Error setting interview remarks:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintAdmissionChallanAction = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }

    setLoading(true);

    const API_BASE_URL = process.env.REACT_APP_API_URL;

    try {
      const response = await fetch(
        `${API_BASE_URL}Student/GenerateAdmissionChallan?FirstRegistrationId=${firstRegistrationId}&createdBy=${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      window.open(url);

      getRegistrationsList();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintChallanAction = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }

    setLoading(true);

    const API_BASE_URL = process.env.REACT_APP_API_URL;

    try {
      const response = await fetch(
        `${API_BASE_URL}Student/GenerateInvoice?FirstRegistrationId=${firstRegistrationId}&createdBy=${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(url);

      getRegistrationsList();

      // Optionally revoke the object URL after some time
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100); // Adjust timeout as needed
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdmissionFeeModalClick = async (event, id) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await get(
        `AssessmentType/GetAdmissionVoucherByRegIdAsync?studentFirstRegistrationId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.isSuccess) {
        setAdmissionFeeModalData(response.admissionVoucher);
        setShowAdmissionFeeModal(true);
      } else {
        console.error(
          "Error fetching admission fee details:",
          response?.message
        );
      }
    } catch (error) {
      console.error("Error fetching admission voucher:", error);
    } finally {
      setLoading(false);
    }
  };

  // Update handleAttachmentFileChange to use RegPaymentProofModal
  const handleAttachmentFileChange = async (event, index) => {
    event.preventDefault();
    setRegPaymentProofModalData({ id: index });
    setPaymentProofType("registration");
    setShowRegPaymentProofModal(true);
  };

  // Update handleAttachmentAdmissionFileChangeA to use RegPaymentProofModal
  const handleAttachmentAdmissionFileChangeA = async (event, index) => {
    event.preventDefault();
    setRegPaymentProofModalData({ id: index });
    setPaymentProofType("admission");
    setShowRegPaymentProofModal(true);
  };

  // New function to handle RegPaymentProofModal submission
  const handleRegPaymentProofSubmit = async (formData) => {
    setLoading(true);
    try {
      const nextStepId =
        workflowSteps[formData.studentFirstRegistrationId]?.id || 0;
      const endpoint =
        paymentProofType === "registration"
          ? "Student/AddStudentRegistrationChallanReceipt"
          : "Student/AddStudentAdmissionChallanReceipt";
      const notificationEvent =
        paymentProofType === "registration"
          ? NotificationEventTypes.UPLOAD
          : NotificationEventTypes.ATTACH;

      const payload = {
        ReceiptName: formData.receiptName,
        Base64Url: formData.base64Url,
        StudentFirstRegistrationId: formData.studentFirstRegistrationId,
        createdBy: localStorage.getItem("userId"),
        FormId: 82,
        NotificationEventTypeIds: notificationEvent.toString(),
        Workflow: {
          WorkflowProcessId: WorkflowProcessIds.NewRegistration,
          WorkflowStepId: nextStepId,
          DBObjectId: DBObjectIds.StudentFirstRegistrations,
          DBObjectLocationId: formData.studentFirstRegistrationId,
          createdBy: Number(userId),
          Comments: "",
        },
      };

      const response = await post(endpoint, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        setShowRegPaymentProofModal(false);
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to upload payment proof");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true, omit: true },
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Admission No.",
      selector: (row) => row.code,
      sortable: true,
      width: "130px",
    },
    {
      name: "Pupil Name",
      selector: (row) => `${row.firstName} ${row.lastName}`,
      sortable: true,
      width: "150px",
    },
    {
      name: "Registration Fee",
      selector: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {row.isPaidRegistration ? (
            <span
              className="fs-8 fas fa-check-circle text-success cursor-pointer"
              onClick={(event) => handleRegFeeModalClick(event, row.id)}
            ></span>
          ) : (
            <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
          )}
          {(workflowSteps[row.id]?.name === "Registration Challan" ||
            row.registrationVoucherNo !== "") && (
            <>
              <button
                style={{ width: "20px", marginLeft: "10px" }}
                type="button"
                className="btn py-1 px-0 border-0 custom-disabled-btn"
                data-tooltip-id="global-tooltip"
                data-tooltip-content="Print Registration Challan"
                onClick={() => handlePrintChallanAction(row.id)}
              >
                <i className="text-primary fs-9 fas fa-print"></i>
              </button>
              {row.registrationVoucherNo !== "" && !row.isPaidRegistration && (
                <button
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  type="button"
                  className="btn py-1 px-0 border-0 custom-disabled-btn"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content={
                    row.receiptFilePath
                      ? "Re-upload Registration Payment Proof"
                      : "Upload Registration Payment Proof"
                  }
                  onClick={(event) => handleAttachmentFileChange(event, row.id)}
                >
                  <i className="text-primary fs-9 fas fa-upload"></i>
                </button>
              )}
              {row.receiptFilePath !== "" && (
                <a
                  href={
                    process.env.REACT_APP_LIVE_DOMAIN_URL +
                    "ExternalImages" +
                    row.receiptFilePath
                  }
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="Preview"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary"
                  style={{ marginLeft: "12px" }}
                >
                  <i className="fa fa-receipt"></i>
                </a>
              )}
            </>
          )}
        </div>
      ),
      width: "150px",
    },
    {
      name: "Assessment Date",
      selector: (row) =>
        row.isAssessmentAdded ? (
          <span
            className="fs-8 fas fa-check-circle text-success cursor-pointer"
            onClick={(event) => handleAssessmentDateModalClick(event, row.id)}
          ></span>
        ) : (
          <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
        ),
      width: "150px",
    },
    {
      name: "Assessment Marks",
      selector: (row) =>
        row.isAssessmentMarksAdded ? (
          <span
            className="fs-8 fas fa-check-circle text-success cursor-pointer"
            onClick={(event) =>
              handleAssessmentMarksModalClick(event, row.id, row.centerClassId)
            }
          ></span>
        ) : (
          <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
        ),
      width: "150px",
    },
    {
      name: "Interview Scheduled",
      selector: (row) =>
        row.isInterviewScheduled ? (
          <>
            <span
              className="fs-8 fas fa-check-circle text-success cursor-pointer"
              onClick={(event) => handleInterviewDateModalClick(event, row.id)}
            ></span>
            {/* <span
              className="fs-8 fas fa-check-circle text-success cursor-pointer"
              onClick={() => handleInterviewDateModalClick(row.id)}
            ></span> */}
          </>
        ) : (
          <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
        ),
      width: "150px",
    },
    {
      name: "Interview Taken",
      selector: (row) =>
        row.isInterviewTaken ? (
          <>
            <span
              className="fs-8 fas fa-check-circle text-success cursor-pointer"
              onClick={(event) => handleInterviewRemarksModalClick(event, row)}
            ></span>
            <span
              className="fs-8 fa-solid fa-circle-question text-primary cursor-pointer text-end ms-1"
              onClick={() =>
                (window.location.href = "/parent-questionnaire-form")
              }
              data-tooltip-id="global-tooltip"
              data-tooltip-content="Parent Questionnaire"
            ></span>
          </>
        ) : (
          <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
        ),
      width: "150px",
    },
    // {
    //   name: "Admission Fee",
    //   selector: (row) => (
    //     <div style={{ display: "flex", alignItems: "center" }}>
    //       {row.isPaidAdmission ? (
    //         <span
    //           className="fs-8 fas fa-check-circle text-success cursor-pointer"
    //           onClick={(event) => handleAdmissionFeeModalClick(event, row.id)}
    //         ></span>
    //       ) : (
    //         <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
    //       )}
    //       {row.isCenterSubmit && row.isAccountApproved && (
    //         <>
    //           <button
    //             style={{ width: "20px", marginLeft: "10px" }}
    //             type="button"
    //             className="btn py-1 px-0 border-0 custom-disabled-btn"
    //             data-tooltip-id="global-tooltip"
    //             data-tooltip-content="Print Admission Challan"
    //             onClick={() => handlePrintAdmissionChallanAction(row.id)}
    //             disabled={
    //               !row.isAccountApproved ||
    //               (row.centerConcessionId !== null && !row.isCEOApproved)
    //             }
    //           >
    //             <i className="text-primary fs-9 fas fa-print"></i>
    //           </button>
    //           {row.admissionVoucherNo !== "" &&
    //             row.admissionReceiptFilePath == "" && (
    //               <>
    //                 <input
    //                   type="file"
    //                   accept="image/*"
    //                   id={`file-upload-admission-${row.id}`}
    //                   style={{ display: "none" }}
    //                   onChange={(event) =>
    //                     handleAttachmentAdmissionFileChangeA(event, row.id)
    //                   }
    //                   disabled={!row.isAccountApproved}
    //                 />
    //                 <label
    //                   htmlFor={`file-upload-admission-${row.id}`}
    //                   style={{
    //                     marginLeft: "10px",
    //                     cursor: row.isAccountApproved
    //                       ? "pointer"
    //                       : "not-allowed",
    //                   }}
    //                   className="btn py-1 px-0 border-0 custom-disabled-btn"
    //                   data-tooltip-id="global-tooltip"
    //                   data-tooltip-content="Payment Proof"
    //                 >
    //                   <i className="text-primary fs-9 fas fa-upload"></i>
    //                 </label>
    //               </>
    //             )}
    //           {fileUrls[row.id] && (
    //             <span style={{ marginLeft: "10px" }}>
    //               {/* {`Uploaded: ${fileUrls[row.id].fileName}`} */}
    //             </span>
    //           )}
    //           {row.admissionReceiptFilePath !== "" && (
    //             <a
    //               href={
    //                 process.env.REACT_APP_LIVE_DOMAIN_URL +
    //                 "ExternalImages" +
    //                 row.admissionReceiptFilePath
    //               }
    //               data-tooltip-id="global-tooltip"
    //               data-tooltip-content="Preview"
    //               target="_blank"
    //               rel="noopener noreferrer"
    //               className="ms-2 text-secondary"
    //               style={{
    //                 pointerEvents: row.isAccountApproved ? "auto" : "none",
    //               }}
    //             >
    //               <i className="fa fa-paperclip"></i>
    //             </a>
    //           )}
    //         </>
    //       )}
    //     </div>
    //   ),
    //   width: "150px",
    // },
    // Update Admission Fee column in columns array
    {
      name: "Admission Fee",
      selector: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {row.isPaidAdmission ? (
            <span
              className="fs-8 fas fa-check-circle text-success cursor-pointer"
              onClick={(event) => handleAdmissionFeeModalClick(event, row.id)}
            ></span>
          ) : (
            <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
          )}
          {(workflowSteps[row.id]?.name === "Admission Challan" ||
            row.admissionVoucherNo !== "") && (
            <>
              <button
                style={{ width: "20px", marginLeft: "10px" }}
                type="button"
                className="btn py-1 px-0 border-0 custom-disabled-btn"
                data-tooltip-id="global-tooltip"
                data-tooltip-content="Print Admission Challan"
                onClick={() => handlePrintAdmissionChallanAction(row.id)}
              >
                <i className="text-primary fs-9 fas fa-print"></i>
              </button>
              {row.admissionVoucherNo !== "" && !row.isPaidAdmission && (
                <button
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  type="button"
                  className="btn py-1 px-0 border-0 custom-disabled-btn"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content={
                    row.admissionReceiptFilePath
                      ? "Re-upload Admission Payment Proof"
                      : "Upload Admission Payment Proof"
                  }
                  onClick={(event) =>
                    handleAttachmentAdmissionFileChangeA(event, row.id)
                  }
                >
                  <i className="text-primary fs-9 fas fa-upload"></i>
                </button>
              )}
              {row.admissionReceiptFilePath !== "" && (
                <a
                  href={
                    process.env.REACT_APP_LIVE_DOMAIN_URL +
                    "ExternalImages" +
                    row.admissionReceiptFilePath
                  }
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="Preview"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" text-primary"
                  style={{ marginLeft: "12px" }}
                >
                  <i className="fa fa-receipt"></i>
                </a>
              )}
            </>
          )}
        </div>
      ),
      width: "150px",
    },
    {
      name: "Acceptance Status",
      selector: (row) =>
        row.isPaidAdmission && row.isCEOApproved ? (
          <span className="badge bg-success fs-10">Accepted</span>
        ) : row.hasObservation ? (
          <span className="badge bg-warning fs-10">Observation</span>
        ) : row.shouldRetakeExam ? (
          <span className="badge bg-danger fs-10">Retake Assessment</span>
        ) : (
          <span className="fs-8 fas fa-circle-exclamation text-black-50"></span>
        ),
      width: "150px",
    },
  ];

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Application Status</h2>
      </div>
      {registrationsData.length > 0 ? (
        <div className="card mb-5">
          <div className="card-body">
            <DataTable
              columns={columns}
              data={registrationsData}
              pagination
              dense
              customStyles={customTableStyles}
              highlightOnHover
              onChangePage={setCurrentPage}
              onChangeRowsPerPage={setRowsPerPage}
            />
          </div>
        </div>
      ) : roleId === "11" ? (
        <div className="text-center">
          <div style={{ minHeight: "400px" }}>
            <img
              className="img-fluid"
              src={visitorDashboardBanner}
              alt="Visitor Dashboard Banner"
            />
          </div>
          <div className="text-end">
            <Link to="/registration-form" className="btn btn-primary mt-3">
              Apply Now
            </Link>
          </div>
        </div>
      ) : (
        <div className="text-center">
          <p>No registration data available.</p>
        </div>
      )}
      {showRegFeeModal && (
        <RegFeeStatusModal
          title="Registration Fee"
          onClose={() => setShowRegFeeModal(false)}
          regFeeModalData={regFeeModalData}
        />
      )}
      {showAssessmentDateModal && (
        <AssessmentDateStatusModal
          title="Assessment Date"
          onClose={() => setShowAssessmentDateModal(false)}
          modalData={assessmentDateModalData}
        />
      )}
      {showAssessmentMarksModal && (
        <AssessmentMarksStatusModal
          title="Assessment Marks"
          onClose={() => setShowAssessmentMarksModal(false)}
          modalData={assessmentMarksModalData}
        />
      )}
      {showInterviewDateModal && (
        <InterviewDateStatusModal
          title="Interview Date"
          onClose={() => setShowInterviewDateModal(false)}
          modalData={interviewDateModalData}
        />
      )}
      {showInterviewRemarksModal && (
        <InterviewRemarksStatusModal
          title="Interview Remarks"
          onClose={() => setShowInterviewRemarksModal(false)}
          modalData={interviewRemarksModalData}
        />
      )}
      {showAdmissionFeeModal && (
        <AdmissionFeeStatusModal
          title="Admission Fee"
          onClose={() => setShowAdmissionFeeModal(false)}
          admissionFeeModalData={admissionFeeModalData}
        />
      )}
      {showRegPaymentProofModal && (
        <RegPaymentProofModal
          title={
            paymentProofType === "registration"
              ? "Registration Payment Proof"
              : "Admission Payment Proof"
          }
          onClose={() => setShowRegPaymentProofModal(false)}
          modalData={regPaymentProofModalData}
          submitData={handleRegPaymentProofSubmit}
        />
      )}
      {loading && <FullScreenLoader />}
    </>
  );
}

export default ApplicationStatus;
